import { useState, useEffect, useCallback, useRef } from "react";

const ITEM_HEIGHT_PX = 56;
const ITEM_HEIGHT_MARGIN_PX = 2;
const MAX_VISIBLE_ITEMS = 5;

export const useDynamicDropdownList = (
  ref,
  { itemCount = 0, open = false, listRef },
) => {
  const [directionUp, setDirectionUp] = useState(false);
  const [dropdownListStyle, setDropdownListStyle] = useState({});
  const [absoluteStyle, setAbsoluteStyle] = useState({});
  const directionLockedRef = useRef(false);

  const estimatedHeight = Math.min(
    Math.max(
      itemCount * ITEM_HEIGHT_PX,
      ITEM_HEIGHT_PX - ITEM_HEIGHT_MARGIN_PX,
    ),
    ITEM_HEIGHT_PX * MAX_VISIBLE_ITEMS,
  );

  const updatePosition = useCallback(() => {
    if (!ref?.current) return;

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    let openUp = directionLockedRef.current
      ? directionUp
      : spaceBelow < estimatedHeight && spaceAbove > estimatedHeight;

    if (!directionLockedRef.current) {
      setDirectionUp(openUp);
      directionLockedRef.current = true;
    }

    setDropdownListStyle({
      position: "fixed",
      left: rect.left,
      width: rect.width,
      top: openUp ? rect.top - estimatedHeight : rect.bottom,
    });

    setAbsoluteStyle({
      position: "absolute",
      ...(openUp && { top: -estimatedHeight }),
    });
  }, [ref, estimatedHeight]);

  useEffect(() => {
    if (!open) {
      directionLockedRef.current = false;
    }
  }, [open]);

  useEffect(() => {
    if (open) updatePosition();
  }, [estimatedHeight]);

  useEffect(() => {
    if (!open) return;

    const toAbsolute = (e) => {
      // 리스트 내부 스크롤이면 무시
      if (listRef?.current?.contains(e.target)) return;
      setDropdownListStyle(absoluteStyle);
    };

    window.addEventListener("scroll", toAbsolute, true);
    return () => window.removeEventListener("scroll", toAbsolute, true);
  }, [open, absoluteStyle, listRef]);

  return { directionUp, dropdownListStyle, updatePosition };
};
